import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import MainHome from "./views/MainHome.vue";
import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
// import Profile from "./views/Profile1.vue";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "home",
      components: {
        header: AppHeader,
        default: MainHome,
        footer: AppFooter
      }
    },
    // {
    //   path: "/components",
    //   name: "components",
    //   components: {
    //     header: AppHeader,
    //     default: Components,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: "/landing",
    //   name: "landing",
    //   components: {
    //     header: AppHeader,
    //     default: Landing,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: "/login",
    //   name: "login",
    //   components: {
    //     header: AppHeader,
    //     default: Login,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: "/register",
    //   name: "register",
    //   components: {
    //     header: AppHeader,
    //     default: Register,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: "/profile",
    //   name: "profile",
    //   components: {
    //     header: AppHeader,
    //     default: Profile,
    //     footer: AppFooter
    //   }
    // },
    {
      path: "/history",
      name: "history",
      components: {
        header: AppHeader,
        default: ()=> import("./views/History.vue"),
        footer: AppFooter
      }
    },
    {
      path: "/introduce",
      name: "introduce",
      components: {
        header: AppHeader,
        default: ()=> import("./views/Introduce.vue"),
        footer: AppFooter
      }
    },
    {
      path: "/benefit",
      name: "benefit",
      components: {
        header: AppHeader,
        default: ()=> import("./views/Benefit.vue"),
        footer: AppFooter
      }
    },
    {
      path: "/location",
      name: "location",
      components: {
        header: AppHeader,
        default: ()=> import("./views/Location.vue"),
        footer: AppFooter
      }
    },
    {
      path: "/buscivil",
      name: "buscivil",
      components: {
        header: AppHeader,
        default: ()=> import("./views/BusCivil.vue"),
        footer: AppFooter
      }
    },
    // {
    //   path: "/busconstruction",
    //   name: "busconstruction",
    //   components: {
    //     header: AppHeader,
    //     default: ()=> import("./views/BusConstruction.vue"),
    //     footer: AppFooter
    //   }
    // },
    {
      path: "/bussewage",
      name: "bussewage",
      components: {
        header: AppHeader,
        default: ()=> import("./views/BusSewage.vue"),
        footer: AppFooter
      }
    },
    {
      path: "/busess",
      name: "busess",
      components: {
        header: AppHeader,
        default: ()=> import("./views/BusEss.vue"),
        footer: AppFooter
      }
    },
    {
      path: "/reference",
      name: "reference",
      components: {
        header: AppHeader,
        default: ()=> import("./views/Reference.vue"),
        footer: AppFooter
      }
    },
    {
      path: "/qanda",
      name: "qanda",
      components: {
        header: AppHeader,
        default: ()=> import("./views/QandA.vue"),
        footer: AppFooter
      }
    },
    {
      path: "/customer",
      name: "customer",
      components: {
        header: AppHeader,
        default: ()=> import("./views/Customer.vue"),
        footer: AppFooter
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  mode: "history"
});
